import SetScheduleFormContainer from './set_schedule_form_container';

const SetScheduleForm = SetScheduleFormContainer;
export default SetScheduleForm;
